import { Cookies } from 'react-cookie';

import { AddHubDataApiResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getAddHubsData = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/add_hub_to_object/${slug}`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as AddHubDataApiResponse;
};
